<template>
  <div class="container 404">
    <div class="row justify-content-center">
      <div class="not-found">
        <div class="innerbox">
          <img src="/assets/img/svg/404.svg" alt>
          <span>404</span>
        </div>
        <span>Pagina non trovata!</span>
        <div class="nav nav-not-found">
          <div class="wrapper">
            <nav class="tabs">
              <router-link v-if="loggedIn" to="/" class="active">
                <i class="bar-chart"></i>
                <span>Home</span>
              </router-link>
              <router-link v-else to="/login" class="active">
                <i class="key"></i>
                <span>Login</span>
              </router-link>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
